export default __webpack_public_path__ + "static/media/img_post1_1.e0bf8c0d.png";